module.exports = __webpack_public_path__ + "assets/img/modal-avatar-bbc41738.png";